import axios from './axios-config';

// Safety Projects
export const getSafetyProjectsWithPagination = (reqData) =>
  axios.post('/safety/projects/with-pagination', reqData);

export const getSafetyProject = (id) => axios.get(`/safety/projects/${id}`);

export const createSafetyProject = (data) => axios.post('/safety/projects', data);

export const updateSafetyProject = (id, data) => axios.put(`/safety/projects/${id}`, data);

export const deleteSafetyProject = (id) => axios.delete(`/safety/projects/${id}`);

// Daily Forms
export const getDailyFormsWithPagination = (reqData) =>
  axios.post('/safety/daily-forms/with-pagination', reqData);

export const getDailyForm = (id) => axios.get(`/safety/daily-forms/details/${id}`);

export const createDailyForm = (data) => axios.post('/safety/daily-forms', data);

export const updateDailyForm = (id, data) => axios.put(`/safety/daily-forms/${id}`, data);

// Skyclimber Forms
export const getSkyclimberFormsWithPagination = (reqData) =>
  axios.post('/safety/skyclimber-forms/with-pagination', reqData);

export const getSkyclimberForm = (id) => axios.get(`/safety/skyclimber-forms/details/${id}`);

export const createSkyclimberForm = (data) => axios.post('/safety/skyclimber-forms', data);

export const updateSkyclimberForm = (id, data) => axios.put(`/safety/skyclimber-forms/${id}`, data);

// Toolbox Talks
export const getToolboxTalksWithPagination = (reqData) =>
  axios.post('/safety/toolbox-talks/with-pagination', reqData);

export const getToolboxTalk = (id) => axios.get(`/safety/toolbox-talks/${id}`);

export const uploadToolboxTalk = (formData) => axios.post('/safety/toolbox-talks', formData);

export const updateToolboxTalk = (id, data) => axios.put(`/safety/toolbox-talks/${id}`, data);

// Safety Documents
export const getSafetyDocumentsWithPagination = (reqData) =>
  axios.post('/safety/documents/with-pagination', reqData);

export const uploadSafetyDocument = (formData) => axios.post('/safety/documents', formData);

export const updateSafetyDocument = (id, data) => axios.put(`/safety/documents/${id}`, data);

// Reports
export const getDailyFormsReport = (reqData) =>
  axios.post('/safety/reports/daily-forms/with-pagination', reqData);

export const getSkyclimberReport = (reqData) =>
  axios.post('/safety/reports/skyclimber/with-pagination', reqData);

export const getToolboxTalksReport = (reqData) =>
  axios.post('/safety/reports/toolbox-talks/with-pagination', reqData);

// Safety Config
export const getSafetyConfigs = () => axios.get('/safety/config');

export const createSafetyConfig = (data) => axios.post('/safety/config', data);

export const updateSafetyConfig = (id, data) => axios.put(`/safety/config/${id}`, data);

export const deleteSafetyConfig = (id) => axios.delete(`/safety/config/${id}`);

export const openAuthenticatedPdf = async (path) => {
  const response = await axios.get(path, { responseType: 'blob' });
  const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  window.open(blobUrl, '_blank');
};
